import { createLucideIcon } from 'lucide-react';

export const ChartPie = createLucideIcon('chart-pie', [
  [
    'path',
    {
      d: 'M12 11.4872H21',
      key: '13avp0',
    },
  ],
  [
    'path',
    {
      d: 'M12 11.4872L17.5 19',
      key: '1nir9c',
    },
  ],
  [
    'path',
    {
      d: 'M12 11.4872V3',
      key: '1ormm7',
    },
  ],
  [
    'path',
    {
      d: 'M3 12C3 7.03846 7.03846 3 12 3C16.9615 3 21 7.03846 21 12C21 16.9615 16.9615 21 12 21C7.03846 21 3 16.9615 3 12Z',
      key: 'k0u2cd',
    },
  ],
]);
